/* Pod and Roll - Guia de tallas. Las MEDIDAS estan en el bloque de datos de abajo. */
var PRSizeGuide = (function(){

  /* ---------------------------------------------------------------
     MEDIDAS. Único sitio que hay que tocar para actualizar cifras.
     body = [talla, largo, pecho mín, pecho máx]   ·   prod = [talla, largo, ancho]
     Camiseta: datos de la ficha del proveedor, verificados 29/08/2026.
     Sudaderas: medidas de prenda de la ficha del proveedor. La tabla
     corporal es la del cuello redondo, aplicada también a la capucha
     por decisión propia: la del proveedor para la capucha asigna a
     cada talla un cuerpo que no cabe en la prenda. Revisar cuando
     haya muestra física medida.
  ----------------------------------------------------------------*/
  var SUD_BODY = [
    ["S",68.6,83.8,91.4],["M",71,94,101.6],["L",73.7,104,109.2],
    ["XL",76.2,111.8,116.8],["2XL",78.7,119.4,124.5],["3XL",81.3,127,132]
  ];
  var SUD_PROD = [
    ["S",68.6,50.8],["M",71,53.3],["L",73.7,58.4],
    ["XL",76.2,63.5],["2XL",78.7,67.3],["3XL",81.3,71]
  ];
  var SUD_NOTE = "Puede variar hasta 5 cm. Es una prenda de corte ajustado: si dudas entre dos tallas, "+
                 "o la quieres holgada, sube una. <b>Mejor que sobre groove.</b>";

  var G = {
    bc3001: {
      name:"Camiseta unisex", spec:"Algodón peinado · manga corta",
      kind:"tee", snug:false, sleeve:null,
      body:[
        ["XS",68.6,78.7,86.4],["S",71,86.4,94],["M",73.7,96.5,104],["L",76.2,106.7,114.3],
        ["XL",78.7,116.8,124.5],["2XL",81.3,127,134.6],["3XL",83.8,137.2,144.8],
        ["4XL",86.4,147.3,155],["5XL",89,157.5,165]
      ],
      prod:[
        ["XS",68.6,42],["S",71,45.7],["M",73.7,50.8],["L",76.2,56],["XL",78.7,61],
        ["2XL",81.3,66],["3XL",83.8,71],["4XL",86.4,76.2],["5XL",89,81.3]
      ],
      note:"Puede variar hasta 5 cm. Si dudas entre dos tallas, sube una. <b>Mejor que sobre groove.</b>"
    },
    m2580: {
      name:"Sudadera con capucha", spec:"Felpa de algodón · bolsillo canguro",
      kind:"hood", snug:true, sleeve:[59.7,61],
      body:SUD_BODY, prod:SUD_PROD, note:SUD_NOTE
    },
    m2480: {
      name:"Sudadera de cuello redondo", spec:"Felpa de algodón · puños y bajo elásticos",
      kind:"crew", snug:true, sleeve:[59.7,61],
      body:SUD_BODY, prod:SUD_PROD, note:SUD_NOTE
    }
  };

  var q = function(id){ return document.getElementById(id); };
  var cur = "bc3001", unit = "cm", lastFind = null;

  function conv(v){
    if(unit === "cm") return String(v).replace(".", ",");
    return String(Math.round(v / 2.54 * 4) / 4).replace(".", ",");
  }
  function u(){ return unit; }

  function rows(g){
    var b = '<thead><tr><th>Talla</th><th>Largo ('+u()+')</th><th>Pecho ('+u()+')</th></tr></thead><tbody>';
    g.body.forEach(function(r){
      b += '<tr data-size="'+r[0]+'"><td>'+r[0]+'</td><td>'+conv(r[1])+'</td><td>'+conv(r[2])+' – '+conv(r[3])+'</td></tr>';
    });
    b += '</tbody>';

    var p = '<thead><tr><th>Talla</th><th>Largo ('+u()+')</th><th>Ancho ('+u()+')</th></tr></thead><tbody>';
    g.prod.forEach(function(r){
      p += '<tr><td>'+r[0]+'</td><td>'+conv(r[1])+'</td><td>'+conv(r[2])+'</td></tr>';
    });
    p += '</tbody>';

    q("tBody").innerHTML = b;
    q("tProd").innerHTML = p;

    var note = g.note;
    if(g.sleeve){
      note += ' Largo de manga: '+conv(g.sleeve[0])+' '+u()+' en la S y '+
              conv(g.sleeve[1])+' '+u()+' en el resto de tallas.';
    }
    q("noteBody").innerHTML = note;
    q("noteProd").innerHTML = note;

    if(lastFind) mark(lastFind);
  }

  function mark(size){
    var tr = q("tBody").querySelectorAll("tr");
    for(var i=0;i<tr.length;i++) tr[i].classList.remove("hit");
    var el = q("tBody").querySelector('tr[data-size="'+size+'"]');
    if(el) el.classList.add("hit");
  }

  function find(){
    var g = G[cur], raw = parseFloat(String(q("findVal").value).replace(",", "."));
    var out = q("findOut");
    out.className = "sg-out";

    if(isNaN(raw)){
      out.className = "sg-out err";
      out.textContent = "Escribe tu medida de pecho para ver la talla.";
      return;
    }

    var cm = unit === "cm" ? raw : raw * 2.54;
    var t = g.body, first = t[0], last = t[t.length-1];

    if(cm < first[2]){
      out.className = "sg-out err";
      out.innerHTML = "Esa medida queda por debajo de la "+first[0]+", que empieza en "+
                      conv(first[2])+" "+u()+". Escríbenos y te ayudamos.";
      return;
    }
    if(cm > last[3]){
      out.className = "sg-out err";
      out.innerHTML = "Esa medida supera la "+last[0]+", que llega hasta "+
                      conv(last[3])+" "+u()+". Escríbenos y te ayudamos.";
      return;
    }

    var pick = null, gap = false, i;
    for(i=0;i<t.length;i++){
      if(cm >= t[i][2] && cm <= t[i][3]){ pick = t[i][0]; break; }
    }
    if(!pick){
      for(i=0;i<t.length;i++){ if(cm < t[i][2]){ pick = t[i][0]; gap = true; break; } }
    }

    lastFind = pick;
    mark(pick);

    var msg = gap
      ? "Estás justo entre dos tallas. Te recomendamos la <b>"+pick+"</b>: mejor que sobre groove."
      : "Tu talla es la <b>"+pick+"</b>.";
    if(g.snug){
      msg += "<em>Es una prenda de corte ajustado. Si la quieres holgada o para llevar encima de "+
             "otra ropa, coge la siguiente.</em>";
    }
    out.innerHTML = msg;
  }

  /* ---------- siluetas: una por prenda y por pestaña ---------- */
  var HEAD =
    '<circle class="fg-body" cx="100" cy="34" r="17"/>'+
    '<path class="fg-body" d="M79 30 A21 21 0 0 1 121 30 L121 34 L117 34 A17 17 0 0 0 83 34 L79 34 Z"/>'+
    '<rect class="fg-body" x="74" y="26" width="9" height="18" rx="4"/>'+
    '<rect class="fg-body" x="117" y="26" width="9" height="18" rx="4"/>'+
    '<rect class="fg-body" x="93" y="50" width="14" height="10"/>';

  var TAPE =
    '<path class="fg-ghost" d="M56 108 C56 100 144 100 144 108"/>'+
    '<path class="fg-line" d="M56 108 C56 120 144 120 144 108"/>'+
    '<text class="fg-txt" x="100" y="140" text-anchor="middle">pecho</text>';

  function svg(inner, label){
    return '<svg viewBox="0 0 200 226" role="img" aria-label="'+label+'">'+inner+'</svg>';
  }

  var FIG = {
    tee: {
      body: svg(HEAD+
        '<path class="fg-body" d="M68 64 C68 60 78 57 100 57 C122 57 132 60 132 64 L149 74 L153 118 L137 122 L137 206 L63 206 L63 122 L47 118 L51 74 Z"/>'+
        TAPE, "Silueta con camiseta y la cinta métrica rodeando el pecho"),
      prod: svg(
        '<path class="fg-body" d="M74 24 L62 30 L28 58 L48 84 L60 74 L60 202 L140 202 L140 74 L152 84 L172 58 L138 30 L126 24 C122 38 113 43 100 43 C87 43 78 38 74 24 Z"/>'+
        '<path class="fg-line" d="M16 30 L16 202"/>'+
        '<path class="fg-cap" d="M10 30 L22 30 M10 202 L22 202"/>'+
        '<text class="fg-txt" x="30" y="120">largo</text>'+
        '<path class="fg-line" d="M60 100 L140 100"/>'+
        '<path class="fg-cap" d="M60 94 L60 106 M140 94 L140 106"/>'+
        '<text class="fg-txt" x="100" y="88" text-anchor="middle">ancho</text>',
        "Camiseta extendida con el largo y el ancho marcados")
    },
    crew: {
      body: svg(HEAD+
        '<path class="fg-body" d="M68 64 C68 60 78 57 100 57 C122 57 132 60 132 64 L150 76 L157 162 L138 166 L136 92 L136 206 L64 206 L64 92 L62 166 L43 162 L50 76 Z"/>'+
        TAPE, "Silueta con sudadera de cuello redondo y la cinta rodeando el pecho"),
      prod: svg(
        '<path class="fg-body" d="M74 46 L44 58 L24 148 L46 157 L58 96 L58 204 L142 204 L142 96 L154 157 L176 148 L156 58 L126 46 C122 58 112 63 100 63 C88 63 78 58 74 46 Z"/>'+
        '<path class="fg-det" d="M80 48 C86 60 114 60 120 48"/>'+
        '<path class="fg-line" d="M14 46 L14 204"/>'+
        '<path class="fg-cap" d="M8 46 L20 46 M8 204 L20 204"/>'+
        '<text class="fg-txt" x="28" y="130">largo</text>'+
        '<path class="fg-line" d="M58 104 L142 104"/>'+
        '<path class="fg-cap" d="M58 98 L58 110 M142 98 L142 110"/>'+
        '<text class="fg-txt" x="100" y="92" text-anchor="middle">ancho</text>',
        "Sudadera de cuello redondo extendida con el largo y el ancho marcados")
    },
    hood: {
      body: svg(
        '<path class="fg-body" d="M70 62 C66 26 134 26 130 62 Z"/>'+
        HEAD+
        '<path class="fg-body" d="M68 64 C68 60 78 57 100 57 C122 57 132 60 132 64 L150 76 L157 162 L138 166 L136 92 L136 206 L64 206 L64 92 L62 166 L43 162 L50 76 Z"/>'+
        '<path class="fg-det" d="M78 150 L122 150 L118 176 L82 176 Z"/>'+
        TAPE, "Silueta con sudadera de capucha y la cinta rodeando el pecho"),
      prod: svg(
        '<path class="fg-body" d="M72 50 C68 12 132 12 128 50 Z"/>'+
        '<path class="fg-body" d="M72 46 L44 58 L24 148 L46 157 L58 96 L58 204 L142 204 L142 96 L154 157 L176 148 L156 58 L128 46 Z"/>'+
        '<path class="fg-det" d="M70 152 L130 152 L126 180 L74 180 Z"/>'+
        '<path class="fg-line" d="M14 46 L14 204"/>'+
        '<path class="fg-cap" d="M8 46 L20 46 M8 204 L20 204"/>'+
        '<text class="fg-txt" x="28" y="130">largo</text>'+
        '<path class="fg-line" d="M58 104 L142 104"/>'+
        '<path class="fg-cap" d="M58 98 L58 110 M142 98 L142 110"/>'+
        '<text class="fg-txt" x="100" y="92" text-anchor="middle">ancho</text>',
        "Sudadera con capucha extendida con el largo y el ancho marcados")
    }
  };

  var STEPS_BODY = [
    "<b>Ponte de pie y relájate.</b> Sin hinchar el pecho ni meter tripa: la medida tiene que ser la de verdad.",
    "<b>Rodea la parte más ancha del pecho</b>, pasando por debajo de las axilas y por encima de los omóplatos.",
    "<b>Cinta recta y sin apretar.</b> Que se sostenga sola, con un dedo de holgura.",
    "<b>Busca tu número en la columna Pecho.</b> Si cae entre dos tallas, coge la mayor."
  ];
  function stepsProd(g){
    var prenda = g.kind === "tee" ? "una camiseta" : "una sudadera";
    return [
      "<b>Extiende "+prenda+" que te siente bien</b> sobre una superficie plana, sin arrugas.",
      "<b>Largo:</b> del punto más alto del hombro, junto al cuello, hasta el bajo.",
      "<b>Ancho:</b> de costura a costura, cruzando el pecho a unos 2,5 cm por debajo de la axila.",
      "<b>Compara con la tabla</b> y elige la talla con las cifras más parecidas."
    ];
  }

  function tab(which){
    var g = G[cur], isBody = which === "body";
    q("tabBody").setAttribute("aria-selected", isBody);
    q("tabProd").setAttribute("aria-selected", !isBody);
    q("panBody").hidden = !isBody;
    q("panProd").hidden = isBody;
    q("howFig").innerHTML = FIG[g.kind][isBody ? "body" : "prod"];
    q("howSteps").innerHTML = (isBody ? STEPS_BODY : stepsProd(g))
      .map(function(s){ return "<li>"+s+"</li>"; }).join("");
  }

  function hint(){
    q("findHint").textContent = unit === "cm"
      ? "Rodea la parte más ancha del pecho con una cinta métrica y escribe el número en centímetros."
      : "Rodea la parte más ancha del pecho con una cinta métrica y escribe el número en pulgadas.";
  }

  function open(key){
    var g = G[key];
    if(!g) return;
    cur = key; lastFind = null;
    q("sgTitle").textContent = g.name;
    q("sgSub").textContent = g.spec;
    q("findVal").value = "";
    q("findOut").textContent = "";
    hint();
    rows(g);
    tab("body");
    var veil = q("sgVeil");
    if(veil.parentNode !== document.body) document.body.appendChild(veil);
    veil.classList.add("is-open");
    document.body.style.overflow = "hidden";
    q("findVal").focus();
  }

  function close(){
    q("sgVeil").classList.remove("is-open");
    document.body.style.overflow = "";
  }

  function setUnit(x){
    unit = x;
    q("uCm").setAttribute("aria-pressed", x === "cm");
    q("uIn").setAttribute("aria-pressed", x === "in");
    q("findVal").value = "";
    q("findOut").textContent = "";
    lastFind = null;
    hint();
    rows(G[cur]);
  }

  q("sgClose").onclick = close;
  q("sgVeil").onclick = function(e){ if(e.target === q("sgVeil")) close(); };
  document.addEventListener("keydown", function(e){
    if(e.key === "Escape" && q("sgVeil").classList.contains("is-open")) close();
  });
  q("tabBody").onclick = function(){ tab("body"); };
  q("tabProd").onclick = function(){ tab("prod"); };
  q("uCm").onclick = function(){ setUnit("cm"); };
  q("uIn").onclick = function(){ setUnit("in"); };
  q("findGo").onclick = find;
  q("findVal").addEventListener("keydown", function(e){ if(e.key === "Enter") find(); });
  q("howBtn").onclick = function(){
    var box = q("howIn"), on = box.hidden;
    box.hidden = !on;
    q("howBtn").setAttribute("aria-expanded", on);
    q("howIco").textContent = on ? "–" : "+";
  };

  return { open:open, close:close, data:G };
})();
